const pillarOak = $('#SingleOptionSelector-1-2');
const pillarBlack = $('#SingleOptionSelector-1-0');
const pillarWhite = $('#SingleOptionSelector-1-1');
const cartBtn = document.querySelector('#js-product-add-related-cart-button');
const unpacking = $('#unselect_packing_cost');

pillarOak.click(function () {
  console.log(pillarOak.val());
  cartBtn.classList.add('text_link_orange_cv_soldout');
  cartBtn.innerText = '売り切れ';
  cartBtn.type = 'button';
  cartBtn.disabled = true;
});

pillarBlack.click(function () {
  cartBtn.classList.remove('text_link_orange_cv_soldout');
  cartBtn.classList.add('product_add_related_footer_add_cart_button_text');
  cartBtn.innerText = 'カートに追加する';
  cartBtn.type = 'submit';
  cartBtn.disabled = false;
  console.log(pillarBlack.val());
});

pillarWhite.click(function () {
  cartBtn.classList.remove('text_link_orange_cv_soldout');
  cartBtn.classList.add('product_add_related_footer_add_cart_button_text');
  cartBtn.innerText = 'カートに追加する';
  cartBtn.type = 'submit';
  cartBtn.disabled = false;
  console.log(pillarWhite.val());
});
